import { LtlPipelineViewModel } from "../../../../../../ViewModel/LtlPipelineViewModel";
import { isFirstLtlRoute } from "./IsFirstLtlRoute";

export function getCurrentStartDepartureTime(
  ltlPipeline: LtlPipelineViewModel
) {
  if (isFirstLtlRoute(ltlPipeline)) {
    return null;
  }

  const routing = ltlPipeline.routing || [];
  const lastRouting = routing[routing.length - 1];
  return lastRouting.DepartureTime;
}
